import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                BaseTao Sheet
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Independent research and education platform providing comprehensive BaseTao Spreadsheet guides, reviews, and tools for smarter shopping decisions.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors">
                <i className="ri-twitter-x-line text-sm text-foreground-600"></i>
              </div>
              <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors">
                <i className="ri-pinterest-line text-sm text-foreground-600"></i>
              </div>
              <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors">
                <i className="ri-reddit-line text-sm text-foreground-600"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Home</Link>
              <Link to="/article/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Complete Guide</Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">BaseTao Spreadsheet</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Buy It Now</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  dangerouslySetInnerHTML={{ __html: cat.name }}
                ></a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">More Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  dangerouslySetInnerHTML={{ __html: cat.name }}
                ></a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 BaseTao Sheet. Independent research platform. Not affiliated with BaseTao.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500">Privacy Policy</span>
            <span className="text-xs text-foreground-500">Terms of Use</span>
            <span className="text-xs text-foreground-500">Editorial Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}